module.exports = __webpack_public_path__ + "img/2_3_2_1.650516f7.png";